<template>
  <AppDialog
    title="Preserve historical data?"
    size="medium"
    position="centered"
    :show="show"
    append-to-body
    @close="close"
  >
    <div class="row">
      <div class="col-xs-12">
        <p class="text-muted">
          Whether an App or URL is classified as Core work, Non-core work, or Unproductive depends upon the Job Type
          assigned to the member.
        </p>
        <p>
          Preserving historical data means that the Apps & URLs recorded up to this point will remain classified
          according to the member’s previous Job Type(s).
        </p>
        <div class="d-flex justify-content-end flex-row">
          <AppButton
            type="default"
            class="mr-10"
            @click="confirm(true)"
          >
            Reclassify historical data
          </AppButton>
          <AppButton
            type="primary"
            @click="confirm(false)"
          >
            Preserve historical data
          </AppButton>
        </div>
      </div>
    </div>
  </AppDialog>
</template>

<script>
export default {
  name: 'MemberOccupationChangeDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm(updateHistoricalData) {
      this.$emit('confirm', updateHistoricalData);
    },
  },
};
</script>
